import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import "./videolist.css";

const categories = [
  "すべて", "生成AI", "ChatGPT", "マーケティング", "営業",
  "副業", "目標設計", "案件獲得", "最近アップロードされた動画", "視聴済み"
];

// ここは今後増やしてOK（idはルーティングで使うので一意推奨）
const videos = [
  { id: "64YkJcWh8ns", title: "生成AI Boost初級編第1回" },
  { id: "52VJJMYYkMA&t=3188s", title: "生成AI Boost初級編第2回" },
  { id: "kk7GlxWZAfk&t=1747s", title: "生成AI Boost初級編第3回" },
];

/**
 * サムネ取得用にYouTubeの「純粋な動画ID」だけに正規化
 * - 短縮URL/通常URL/クエリつき/プレーンID すべて対応
 */
const normalizeYoutubeId = (raw) => {
  if (!raw) return "";
  try {
    const u = new URL(raw);
    if (u.hostname.includes("youtube.com")) return (u.searchParams.get("v") || "").trim();
    if (u.hostname.includes("youtu.be")) return (u.pathname.replace("/", "") || "").trim();
  } catch {}
  return raw.split("&")[0].trim(); // ← &t= を除去
};

const getYoutubeThumb = (rawId) =>
  `https://img.youtube.com/vi/${normalizeYoutubeId(rawId)}/hqdefault.jpg`;

const VideoPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("すべて");
  const navigate = useNavigate();

  const handleCardOpen = (videoId) => {
    const idOnly = normalizeYoutubeId(videoId);
    // ここを /videos/:videoId に
    navigate(`/videos/${encodeURIComponent(idOnly)}`);
  };

  const handleCardKeyDown = (e, videoId) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardOpen(videoId);
    }
  };

  return (
    <div className="system-page">
      <Sidebar />

      <main className="videos-wrapper">
        <div className="background-overlay"></div>

        <div className="videos-content">
          <div className="videolist-header">
            <div className="videolist-search-container">
              <input
                type="text"
                placeholder="動画を検索する"
                className="videolist-input"
              />
            </div>

            <div className="category-bar">
              {categories.map((category) => (
                <button
                  key={category}
                  className={`category-button ${selectedCategory === category ? "active" : ""}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* グリッド自体はクリック不可に変更（カード単位で遷移） */}
          <div className="video-grid">
            {videos.map((video) => (
              <div
                key={video.id}
                className="video-card"
                role="button"
                tabIndex={0}
                aria-label={`${video.title} の詳細へ`}
                title={`${video.title} の詳細へ`}
                onClick={() => handleCardOpen(video.id)}
                onKeyDown={(e) => handleCardKeyDown(e, video.id)}
              >
                <div className="video-thumb">
                  <img
                    src={getYoutubeThumb(video.id)}
                    alt={`${video.title}のサムネイル`}
                    loading="lazy"
                  />
                  <img
                    src="/link.png"
                    alt="リンクアイコン"
                    className="link-icon"
                    onClick={(e) => {
                      e.stopPropagation(); // 親のカードクリック遷移を止める
                      const idOnly = normalizeYoutubeId(video.id);
                      const url = `${window.location.origin}/videos/${encodeURIComponent(idOnly)}`;

                      if (navigator.share) {
                        // スマホなど対応環境ならネイティブ共有
                        navigator.share({
                          title: video.title,
                          url,
                        }).catch(err => console.log("共有キャンセル:", err));
                      } else {
                        // PC等はクリップボードにコピー
                        navigator.clipboard.writeText(url).then(() => {
                          alert("動画のURLをコピーしました！");
                        });
                      }
                    }}
                  />
                </div>

                <div className="video-title">{video.title}</div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default VideoPage;
